import request from '@/utils/request'

/**
 * Tag: WXAppUser
 */

const baseUrl ="api_WXAppUser";



/**
 * 同步用户信息
 * @param {*} body
 * {
 *    OpenId Desc:openid Required:true
 *    AppId Desc:appid Required:false
 *    OrgId Desc:机构id Required:false
 *    nickName Desc:用户昵称 Required:false
 *    avatarUrl Desc:用户头像 Required:false
 *    gender Desc:用户的性别，值为1时是男性，值为2时是女性，值为0时是未知 Required:false
 *    city Desc:用户所在城市 Required:false
 *    province Desc:用户所在省份 Required:false
 *    country Desc:用户所在国家 Required:false
 *    language Desc:用户的语言，简体中文为zh_CN Required:false
 *    phone Desc: Required:false
 * }
 */
function _sendUserInfo(body) {
  return request(baseUrl+'_sendUserInfo',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取当前用户信息
 */
function _getUserInfo() {
  return request(baseUrl+'_getUserInfo',{
    method: 'GET',
  });

}



/**
 * 检查当前用户手机号存不存在
 * @param {*} param
 * {
 *    openid Desc: Required:true
 * }
 */
function _checkUserPhone(param) {
  return request(baseUrl+'_checkUserPhone',{
    method: 'GET',
    params: param,
  });

}



/**
 * 根据OpenId获取微信小程序用户表中对应的手机号
 * @param {*} param
 * {
 *    openid Desc: Required:true
 * }
 */
function _getUserPhoneByOpenId(param) {
  return request(baseUrl+'_getUserPhoneByOpenId',{
    method: 'GET',
    params: param,
  });

}



/**
 * 绑定或修改会员手机号
 * @param {*} param
 * {
 *    phone Desc:手机号 Required:true
 *    verifycode Desc:验证码 Required:true
 *    orgid Desc:机构id Required:true
 * }
 */
function _bindOrChangePhone(param) {
  return request(baseUrl+'_bindOrChangePhone',{
    method: 'GET',
    params: param,
  });

}



/**
 * 绑定学员
 * @param {*} param
 * {
 *    phone Desc: Required:true
 *    verifycode Desc: Required:true
 *    orgid Desc: Required:true
 * }
 */
function _bindStudentByPhone(param) {
  return request(baseUrl+'_bindStudentByPhone',{
    method: 'GET',
    params: param,
  });

}



/**
 * 解除绑定
 * @param {*} body
 * {
 *    memberStudentId Desc:关系id Required:true
 * }
 */
function _unBindStudentByPhone(body) {
  return request(baseUrl+'_unBindStudentByPhone',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取机构列表
 */
function _getOrgList() {
  return request(baseUrl+'_getOrgList',{
    method: 'GET',
  });

}



/**
 * 根据会员手机号 获取机构列表
 * @param {*} param
 * {
 *    phone Desc:手机号 Required:true
 *    verifycode Desc:注册验证码 Required:true
 * }
 */
function _getOrgListByPhone(param) {
  return request(baseUrl+'_getOrgListByPhone',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取学员
 * @param {*} param
 * {
 *    orgid Desc: Required:true
 * }
 */
function _getStudentList(param) {
  return request(baseUrl+'_getStudentList',{
    method: 'GET',
    params: param,
  });

}



/**
 * (分享页面) 创建客户
 * @param {*} body
 * {
 *    Name Desc:姓名 Required:true
 *    Phone Desc:手机号 Required:true
 *    Verifycode Desc:手机验证码 Required:true
 *    BranchId Desc:意向校区 Required:true
 *    CourseId Desc:意向课程 Required:true
 *    OrgId Desc:机构id Required:true
 * }
 */
function _createCustomer(body) {
  return request(baseUrl+'_createCustomer',{
    method: 'POST',
    body: body,
  });

}




/**
 * 根据会员手机号和密码 获取机构列表（账号密码登录）
 * @param {*} param
 * {
 *    phone Desc:手机号 Required:true
 *    password Desc:密码 Required:true
 * }
 */
function _getOrgListByPassword(param) {
  return request(baseUrl+'_getOrgListByPassword',{
    method: 'GET',
    params: param,
  });

}



/**
 * 绑定学员（密码登录）
 * @param {*} param
 * {
 *    phone Desc: Required:true
 *    password Desc: Required:true
 *    orgid Desc: Required:true
 * }
 */
function _bindStudentByPassword(param) {
  return request(baseUrl+'_bindStudentByPassword',{
    method: 'GET',
    params: param,
  });

}



/**
 * 修改密码
 * @param {*} param
 * {
 *    oldPassword Desc:原密码 Required:true
 *    newPassword Desc:新密码 Required:true
 * }
 */
function _changePassword(param) {
  return request(baseUrl+'_changePassword',{
    method: 'GET',
    params: param,
  });

}




export default{
  _sendUserInfo,
  _getUserInfo,
  _checkUserPhone,
  _getUserPhoneByOpenId,
  _bindOrChangePhone,
  _bindStudentByPhone,
  _unBindStudentByPhone,
  _getOrgList,
  _getOrgListByPhone,
  _getStudentList,
  _createCustomer,
  _getOrgListByPassword,
  _bindStudentByPassword,
  _changePassword

}




// WEBPACK FOOTER //
// ./src/api/wXAppUser.js